import { ContentHeading } from 'components/Typography';
import { PaymentsCard, RefundBreakdown, BottomTotal } from 'components/payments/primitives';
import CreditVoucherRefundBreakdown from 'components/payments/primitives/CreditVoucherRefundBreakdown';
import { useCancellationQuote } from '../CancellationQuoteProvider';
import { useDetailsBooking } from 'lib/hooks';
import { getPendingScheduledPayment } from 'lib/bookingInfo';
import { Text } from 'roo-ui/components';
import { FormattedMoney } from 'components/Formatters';

const RefundSummary = () => {
  const { refundType, cancellation } = useCancellationQuote();
  const { booking } = useDetailsBooking();
  const pendingPayment = getPendingScheduledPayment(booking);

  return (
    <>
      <ContentHeading>Refund summary</ContentHeading>

      {pendingPayment && (
        <Text as="div" mx={4} mb={[5, 8]} data-hj-suppress data-testid="deposit-pay-cancellation-of-balance-note">
          <strong>Please note: You will not be charged</strong> the remaining payment of <FormattedMoney {...pendingPayment.total} /> for
          this booking
        </Text>
      )}

      {refundType === 'CREDIT_NOTE' ? (
        <CreditVoucherRefundBreakdown voucherTotal={cancellation?.creditNote?.total!} />
      ) : (
        <PaymentsCard mb={8} data-hj-suppress data-testid="normal-refund-breakdown">
          <RefundBreakdown breakdown={cancellation?.refund?.breakdown!} penalty={[]} showHeading={false} />
          <BottomTotal title="Total refund" totals={cancellation?.refund?.totals!} />
        </PaymentsCard>
      )}
    </>
  );
};

export default RefundSummary;
